export default {
    loading: false
}
